import { canv } from "@/canv/global.js";
import { Shape } from "../shape";

export class ShapeDeletion extends Shape {
    needFill = false;
    defaultBorderWidth = 12;
    fillStyleEnabled = false;

    draw(x: number, y: number, w: number, h: number) {
        canv.ctx.beginPath();

        // TODO: нужно после отрисовки этот стиль убирать
        canv.ctx.lineCap = "round";

        canv.ctx.moveTo(x, y);
        canv.ctx.lineTo(x + w, y + h);

        canv.ctx.moveTo(x + w, y);
        canv.ctx.lineTo(x, y + h);

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" stroke="${stroke}" stroke-linecap="round" stroke-linejoin="round" d="M21 3 3 21M3 3l18 18"/>
            </svg>
        `;
    }
}
